.deposit {
  padding: 2rem 3rem;
  display: flex;
  flex-direction: column;
  background-color: var(--deposit-withdraw-bg-color);
  border-radius: 1rem;
  margin: 3rem 2.5rem;
}

.depositDetails {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.availableBalance {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.8rem;
}

.divider {
  height: 1px;
  border-top: 1px solid #dad9d9;
  margin-left: 0.5rem 5%;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.escrowAccount {
  margin-top: 0.5rem;
}

.changeBankAccount {
  width: 60%;
}

.bankDetailsView {
  display: flex;
  justify-content: space-between;
}

@media (min-width: 768px) {
  .bankDetailsView {
    width: 40%;
  }
}

@media (max-width: 767.98px) {
  .bankDetailsView {
    width: 100%;
  }
  .changeBankAccount {
    width: 100%;
  }
  .deposit {
    padding: 1.5rem;
  }
}

.bankDetailsAttr {
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
}
